import { render, staticRenderFns } from "./spinsRate.vue?vue&type=template&id=2acfbf1d&scoped=true&"
import script from "./spinsRate.vue?vue&type=script&lang=js&"
export * from "./spinsRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acfbf1d",
  null
  
)

export default component.exports